import React, { useEffect, useState } from "react";
import Header from "./../../UIComponents/Header/Header";
import Media from "./../../UIComponents/Media/Media";
import AllServices from "./../../UIComponents/AllServices/AllServices";
import Housing from "./../../UIComponents/Housing/Housing";
import DownloadApp from "./../../UIComponents/DownloadApp/DownloadApp";
import ContactUs from "./../../UIComponents/ContactUs/ContactUs";
import Footer from "./../../UIComponents/Footer/Footer";
import ToolCards from "./../../UIComponents/ToolCards/ToolCards";
import InnovationEcosystem from "./../../UIComponents/InnovationEcosystem/InnovationEcosystem";
import ViolationsSuspensions from "./../../UIComponents/ViolationsSuspensions/ViolationsSuspensions";
import PrivacyPolicyModal from "./../../UIComponents/PrivacyPolicyModal";
import axios from "axios";
import { messageAdded } from "features/service/errorMessageSlice";
import { useSelector, useDispatch } from "react-redux";
import { portalStyleAdded } from "features/service/portalStyleSlice";
import loadingGif from "global/imagesTemp/AnimatedGif2.gif";
import AISBullet from './../../../global/images/aisIcon.png'

const Home = () => {
	const [data, setData] = useState({});
	const [showLoadingOverlay, setShowLoadingOverlay] = useState(true);
	const { user } = useSelector((state) => state.user);
	const { Header_Logo, Header_Title, favicon, Show_Offers } = useSelector((state) => state.portalStyle);
	const dispatch = useDispatch();

	useEffect(() => {
		const fetchDepartmentData = async () => {
			await axios
				.post(
					`${process.env.REACT_APP_API_URL}/PORTAL/DEPARTMENTS/GET_DEPARTMENT_INFO`,
					{
						Department_Id: 1,
					}
				)
				.then((res) => setData(res?.data?.Data));
		};
		// const fetchClientsPortalStyle = async () => {
		// 	await axios
		// 		.post(
		// 			`${process.env.REACT_APP_API_URL}/SYSTEM/GENERAL/Get_Clients_Portal_Style`,
		// 			{}
		// 		)
		// 		.then((res) => {
		// 			dispatch(
		// 				portalStyleAdded({
		// 					Colors: res?.data?.Data?.Colors,
		// 					Fonts: res?.data?.Data?.Fonts,
		// 					Footer_Background: res?.data?.Data?.Footer_Background,
		// 					Header_Background: res?.data?.Data?.Header_Background,
		// 					Header_Logo: res?.data?.Data?.Header_Logo,
		// 					Header_Title: res?.data?.Data?.Header_Title,
		// 					Invoices_Logo: res?.data?.Data?.Invoices_Logo,
		// 					Invoices_Payment_Logo: res?.data?.Data?.Invoices_Payment_Logo,
		// 					Notification_POPUP: res?.data?.Data?.Notification_POPUP,
		// 					Profile_Image: res?.data?.Data?.Profile_Image,
		// 					Service_Card_Background: res?.data?.Data?.Service_Card_Background,
		// 					Spinner: res?.data?.Data?.Spinner,
		// 					favicon: res?.data?.Data?.favicon
		// 				})
		// 			);
		// 			setShowLoadingOverlay(false)
		// 		});
		// };

		fetchDepartmentData();
		// fetchClientsPortalStyle();
	}, []);

	useEffect(() => {
		if (user && user?.Client_Profiles[0]?.Profile_Active_Status_Id !== 1) {
			dispatch(
				messageAdded({
					errorEnglish: `Account Status: ${user?.Client_Profiles[0]?.Profile_Active_Status_Name_EN}, Some services will not be available untill the account is activated`,
					errorArabic: `حالة الحساب: ${user?.Client_Profiles[0]?.Profile_Active_Status_Name_AR}, بعض الخدمات غير متاحة حتى يتم تعديل حالة الحساب الى فعال`,
					warning: true,
					errorColor: "warning",
				})
			);
			document.getElementById('theme').style.marginTop = '73px';
			document.getElementById('header').style.top = '73px';
		}
	}, []);

	useEffect(() => {
		if (Header_Logo) {
			setShowLoadingOverlay(false)
		}
	}, [Header_Logo])

	useEffect(() => {
		let link = document.querySelector("link[rel~='icon']");
		let title = document.getElementById("headerTitle");
		if (!link) {
			link = document.createElement('link');
			link.rel = 'icon';
			document.getElementsByTagName('head')[0].appendChild(link);
		}
		// here ais
		link.href = AISBullet;
		// link.href = favicon;
		// title.innerText = `${Header_Title}`;
	}, [Header_Title, favicon])

	return (
		<>
			<Header />
			<Media />
			<AllServices homePage={true} />
			{Show_Offers && <ToolCards />}
			{/* <InnovationEcosystem /> */}
			{/* <Housing /> */}
			{/* <DownloadApp homePage={true} /> */}
			<ContactUs data={data} />
			<Footer data={data} />

			<ViolationsSuspensions />

			{/* here ais */}
			{/* {!showLoadingOverlay && <PrivacyPolicyModal />} */}

			{/* {showLoadingOverlay &&
				<div
					style={{
						position: 'fixed',
						backgroundColor: '#fff',
						// backgroundColor: '#ededed',
						top: '0',
						right: '0',
						left: '0',
						bottom: '0',
						zIndex: '9999999999',
					}}
				>
					<div className="d-flex align-items-center justify-content-center h-100 w-100">
						<img width='400' src={loadingGif} />
					</div>
				</div>
			} */}
		</>
	);
};

export default Home;
